import abank from '../../../assets/banks/abank.png'
import ayabank from '../../../assets/banks/ayabank.png'
import ayapay from '../../../assets/banks/ayapay.png'
import cbbank from '../../../assets/banks/cbbank.png'
import cbpay from '../../../assets/banks/cbpay.png'
import dollar from '../../../assets/banks/dollar.png'
import kbzbank from '../../../assets/banks/kbzbank.png'
import kpay from '../../../assets/banks/kpay.png'
import mabbank from '../../../assets/banks/mabbank.png'
import ok from '../../../assets/banks/ok.png'
import uabbank from '../../../assets/banks/uabbank.png'
import wavepay from '../../../assets/banks/wavepay.png'
import yomabank from '../../../assets/banks/yomabank.png'

export const bankTypeOptions = [
  {
    id: 'kbz',
    name: 'KBZ Bank',
    value: 'kbzbank',
    icon: kbzbank,
    description: 'Retail and business banking',
  },
  {
    id: 'kpay',
    name: 'KBZ Pay',
    value: 'kpay',
    icon: kpay,
    description: 'Mobile wallet',
  },
  {
    id: 'aya',
    name: 'AYA Bank',
    value: 'ayabank',
    icon: ayabank,
    description: 'Corporate and personal accounts',
  },
  {
    id: 'ayapay',
    name: 'AYA Pay',
    value: 'ayapay',
    icon: ayapay,
    description: 'Digital wallet',
  },
  {
    id: 'yoma',
    name: 'Yoma Bank',
    value: 'yomabank',
    icon: yomabank,
    description: 'SME specialist',
  },
  {
    id: 'uab',
    name: 'UAB Bank',
    value: 'uabbank',
    icon: uabbank,
    description: 'Commercial banking',
  },
  {
    id: 'mab',
    name: 'MAB Bank',
    value: 'mabbank',
    icon: mabbank,
    description: 'Retail banking',
  },
  {
    id: 'abank',
    name: 'A Bank',
    value: 'abank',
    icon: abank,
    description: 'Branch focused network',
  },
  {
    id: 'cb',
    name: 'CB Bank',
    value: 'cbbank',
    icon: cbbank,
    description: 'Corporate banking',
  },
  {
    id: 'cbpay',
    name: 'CB Pay',
    value: 'cbpay',
    icon: cbpay,
    description: 'Digital wallet & payments',
  },
  {
    id: 'ok',
    name: 'OK Dollar',
    value: 'ok',
    icon: ok,
    description: 'Cash-in / cash-out',
  },
  {
    id: 'wavepay',
    name: 'Wave Pay',
    value: 'wavepay',
    icon: wavepay,
    description: 'Mobile money wallet',
  },
]

const buildLookup = () => {
  const lookup = new Map()
  bankTypeOptions.forEach((option) => {
    lookup.set(option.value, option)
    //lookup.set(option.id, option)
    //lookup.set(option.name, option)
  })
  return lookup
}

export const bankTypeLookup = buildLookup()

export const normalizeBankTypeValue = (input) => {
  if (!input) return input
  const key =
    typeof input === 'string' ? input : input.value ?? input.id ?? input.name
  const option = bankTypeLookup.get(key)
  return option ? option.value : key
}
